import axios from "axios";

/**
 * API通信用クライアント
 *
 * axios通信用のクライアントです。
 * HTTPヘッダに"application/json"を付与しています
 */
const apiClient = axios.create({
  baseURL: process.env.VUE_APP_API_BASE_URL,
  headers: {
    "Content-Type": "application/json",
    "Cache-Control": "no-cache",
    Pragma: "no-cache",
    Expires: "0",
  },
});

export default apiClient;
